module.exports = {"340225100":"无城镇","340225101":"襄安镇","340225104":"陡沟镇","340225105":"石涧镇","340225106":"严桥镇","340225107":"开城镇","340225108":"蜀山镇","340225109":"牛埠镇","340225110":"刘渡镇","340225111":"姚沟镇","340225112":"泥汊镇","340225114":"福渡镇","340225115":"泉塘镇","340225116":"赫店镇","340225117":"红庙镇","340225118":"高沟镇","340225119":"鹤毛镇","340225120":"十里墩镇","340225121":"昆山镇","340225122":"洪巷镇","340225400":"安徽无为经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340225.json
// module id = 1054
// module chunks = 0